module.exports = {"id":"188070","name":"Ronald Vargas","rating":"72","photo":"./data/images/photos/1/188070.png","club":{"name":"Newcastle Jets","logo":"./data/images/clubs/NewcastleJets.png"},"positions":["MOC"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/RonaldVargas0.json
// module id = 3713
// module chunks = 0